/**
 * Created by AlexanderC on 5/27/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UniversalRequire = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let UniversalRequire = exports.UniversalRequire = function () {
  function UniversalRequire() {
    _classCallCheck(this, UniversalRequire);

    this._require = this._guessRequireFunc();
  }

  /**
   * @param {String} module
   * @param {Function} cb
   * @returns {*}
   */


  _createClass(UniversalRequire, [{
    key: 'require',
    value: function require(module, cb) {
      if (UniversalRequire._isFrontend) {
        module = _path2.default.normalize(module); // avoid './' or '../'
      }

      return this._require(module, cb);
    }

    /**
     * @returns {Boolean}
     * @private
     */

  }, {
    key: '_guessRequireFunc',


    /**
     * @returns {Function}
     * @private
     */
    value: function _guessRequireFunc() {
      if (!UniversalRequire._isFrontend) {
        return (module, cb) => {
          try {
            cb(null, require(module));
          } catch (e) {
            cb(e, null);
          }
        };
      }

      require('./require1k.js');

      return window.__deepRequireBrowser__;
    }
  }], [{
    key: '_isFrontend',
    get: function get() {
      return typeof window !== 'undefined' && typeof document !== 'undefined';
    }
  }]);

  return UniversalRequire;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/Generic/UniversalRequire.js
// module id = 374
// module chunks = 0